/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_UnnamedInputs */



/**
* | output |
* | --- |
* | "Unnamed deck" |
*
* @param {Decks_UnnamedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_unnamed = /** @type {((inputs?: Decks_UnnamedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_UnnamedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck sans nom")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deck sin nombre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck sem nome")
	if (locale === "it") return /** @type {LocalizedString} */ ("Deck senza nome")
	return /** @type {LocalizedString} */ ("Unnamed deck")
});